import Cookies from 'js-cookie'

const TokenKey = 'admin_template_token'
const UserId = 'user_id'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getStorgeItem(key) {
  const value = localStorage.getItem(key)
  if (value === null || value === undefined) {
    return null
  }
  return JSON.parse(value)
}

export function getParseStorge(key) {
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null
}

export function setStorgeItem(key, value) {
  return localStorage.setItem(key, JSON.stringify(value))
}




// WEBPACK FOOTER //
// ./src/utils/auth.js